import shouldForwardProp from '@styled-system/should-forward-prop';
import isNil from 'lodash/isNil';
import styled, { css } from 'styled-components';

import type borders from '../../../theme/borders';
import type { Size } from '../../../theme/icons';

type Props = Readonly<{
  size: Size;
  radius?: keyof typeof borders.radii;
  background?: string;
  color?: string;
}>;

const boxSize = (props: Props) => css`
  height: ${({ theme }) => theme.scTheme.icons.sizes[props.size].box};
  width: ${({ theme }) => theme.scTheme.icons.sizes[props.size].box};
`;

const IconBox = styled.div.withConfig({ shouldForwardProp })<Props>`
  align-items: center;
  display: inline-flex;
  justify-content: center;
  ${boxSize};
  ${({ theme, radius }) => !isNil(radius) && css`border-radius: ${theme.scTheme.borders.radii[radius]};`}
  ${({ background }) => !isNil(background) && css`background-color: ${background};`}
  ${({ color }) => !isNil(color) && css`color: ${color};`}
`;

export default IconBox;
